Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Events = void 0;
var Events = exports.Events = {
  pageview: 'pageview',
  screenview: 'screenview',
  showFullScreenDialog: 'Show FullScreenDialog',
  closeMessage: 'Close message',
  changeLocale: 'Change Locale',
  signIn: 'Sign in',
  signOut: 'Sign out',
  onboardingTakeAStep: 'Onboarding take a step',
  onboardingGoal: 'Onboarding goal',
  createCommitment: 'Create commitment',
  updateCommitment: 'Update commitment',
  suppressStep: 'Suppress action',
  stepFilter: 'Step filter',
  stepsUserFlow: 'Steps User Flow',
  leaderboardDownload: 'Download report',
  whatNext: 'What next',
  footprintFilter: 'Footprint filter',
  existingCheckModal: 'Existing check modal'
};